<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<form [formGroup]="AccountForm">
    <div style="color: #757575; font-size: 18px; font-weight: 600;">Service Center ID</div>
    <div class="d-flex flex-column mt-2" style="gap: 0.5rem;">

        <label for="uniqueid" class="label mb-0">Your unique service center id*</label>
        <div class="d-flex flex-column " style="gap: 0.5rem;">
            <div *ngIf="!isEdit">
                <div class="input-group w-100">
                    <div class="input-group-prepend">
                        <span class="input-group-text" style="border-top-left-radius: 8px;border-bottom-left-radius: 8px;">&#64;</span>
                    </div>
                    <input type="text" id="amount" class="form-control input-fields-q5" formControlName="uniqueID" />
                </div>
                
            </div>
            <div *ngIf="isEdit" class="d-flex align-items-center " style="gap: 0.5rem;">
                <div class="input-group w-100">
                    <div class="input-group-prepend">
                        <span class="input-group-text" style="border-top-left-radius: 8px;border-bottom-left-radius: 8px;">&#64;</span>
                    </div>
                    <input type="text" id="amount" class="form-control input-fields-q5" formControlName="uniqueID" readonly/>
                </div>
                <div (click)="openEditMode()">
                    <i class="bi bi-pencil-square text-dark"></i>
                </div>
            </div>

            <div *ngIf="AccountForm.get('uniqueID')?.invalid">

                <small class="text-danger"
                    *ngIf="AccountForm.get('uniqueID')?.touched && AccountForm.get('uniqueID')?.errors?.['required']">
                    Unique ID is required.
                </small>

                <small class="text-danger" *ngIf="AccountForm.get('uniqueID')?.errors?.['pattern']">
                    Unique ID can contain only letters, numbers, and spaces.
                </small>

            </div>

            <ng-container *ngIf="AccountForm.valid">
                <div *ngIf="domainCheckInProgress" class="spinner-border spinner-border-sm custom-thin-spinner"
                    role="status"></div>
                <div class="availability-status" *ngIf="isDomainAvailable === false" style="min-height: 1rem;">
                    <span>
                        <i class="bi bi-x-circle" style="color: red;"></i>
                    </span>
                    <span>Not available</span>
                </div>
                <div class="availability-status" *ngIf="isDomainAvailable === true" style="min-height: 1rem;">
                    <span>
                        <i class="bi bi-check2-circle" style="color: green;"></i>
                    </span>
                    <span>Available</span>
                </div>
            </ng-container>

        </div>
        <div *ngIf="!isEdit" class="d-flex align-items-center justify-content-end mt-2 ">
            <div class="d-flex align-items-center w-100" style="gap: 0.5rem;">
                <button *ngIf="isSubDomainAdded" (click)="closeEditMode()" type="button"
                    class="btn btn-outline-secondary w-100" style="font-size: 14px;">
                    Cancel
                </button>
                <button *ngIf="!isSubDomainAdded" (click)="clearUniqueID()" type="button"
                    class="btn btn-outline-secondary w-100" style="font-size: 14px;">
                    Clear
                </button>
                <button type="button" id="btnSaveUniqueID" class="btn btn-primary w-100"
                    [disabled]="AccountForm.invalid"
                    style="background-color: #673AB7; color: #fff; border: #673AB7;font-size: 14px;"
                    (click)="saveUniqueID();">Save</button>
            </div>
        </div>
    </div>
</form>